import { Status } from "@covertree/ui/content/StatusLabel";
import { PolicyStatus } from "@covertree/agent-portal-graphql";

export function mapPolicyStatusLabel(status?: PolicyStatus): Status {
  switch (status ?? "") {
    case PolicyStatus.Activated:
    case PolicyStatus.InitialQuote:
      return "active";
    case PolicyStatus.Cancelled:
    case PolicyStatus.Expired:
      return "expired";
    case PolicyStatus.PendingCancellation:
    case PolicyStatus.PendingCancellationEsignRequired:
    case PolicyStatus.PendingCancellationInspection:
    case PolicyStatus.PendingCancellationNonPay:
    case PolicyStatus.PendingCancellationOther:
    case PolicyStatus.PendingEsignRequired:
      return "pending";
    default:
      return "initial";
  }
}
